export default "__VITE_ASSET__Jw15YBYW__"